import React from 'react';
import { Section } from './ui/Section';
export function Guarantee() {
  return <Section variant="alt" data-id="element-94">
      <div className="bg-white border-2 border-brand-primary rounded-lg p-6 text-center max-w-2xl mx-auto shadow-card" data-id="element-95">
        <div className="text-4xl mb-3" data-id="element-96">🛡️</div>

        <h2 className="font-display text-2xl font-bold mb-3 text-brand-primary" data-id="element-97">
          GARANTÍA 7 DÍAS
        </h2>

        <p className="font-body text-brand-text mb-4" data-id="element-98">
          Prueba todo sin riesgos. Si no es para ti, devolución 100% en 48h. Sin
          preguntas.
        </p>

        <p className="font-body text-brand-textMuted text-xs" data-id="element-99">
          +8.000 psicólogos lo usan · Tasa devolución &lt;1%
        </p>
      </div>
    </Section>;
}